import { render, staticRenderFns } from "./CreatePayoutPage.vue?vue&type=template&id=40fca959&scoped=true&"
import script from "./CreatePayoutPage.vue?vue&type=script&lang=js&"
export * from "./CreatePayoutPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePayoutPage.vue?vue&type=style&index=0&id=40fca959&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fca959",
  null
  
)

export default component.exports